import * as React from 'react';
import { ElementLoader, MeatballMenu, PromptConfirmationModal } from 'ui';
import { ids } from 'app/area/administration/constants';
import { CodetableItemProps } from 'app/area/codetable/list/list-items/types';

import styles from './meatball-menu.scss';

export const CodeListMeatballMenu = (props: CodetableItemProps) => {

  const { codetableId, isHierarchy, breadcrumbs, codeItem, translation, parentId,
    codeAccessConfiguration: { canCreate, canDelete, canDuplicate, isCentralAdmin },
    fetchingItemAccess, loadCodesAccess, clearCodesAccess, deleteCodeItem, addLinkFactory } = props;

  const description = !!codeItem && !!codeItem.childrenCount
    ? translation.delete_with_descendants_confirm.replace('<DESCENDANTS>', String(codeItem.childrenCount))
    : translation.delete_confirm;

  const isVisible = codeItem.id !== 0 && canCreate;

  const hasNoAccess = !canDelete && !canCreate;

  const handleDeleteCodeItem = () => {
    deleteCodeItem(codetableId, codeItem.id, translation.code_item_successfully_deleted);
  };

  const handleLoadCodesAccess = () => !isCentralAdmin && loadCodesAccess(codetableId, codeItem.id);
  const handleClearCodesAccess = () => !isCentralAdmin && clearCodesAccess();

  return <div className={styles.meatballContainer}>
    {isVisible && <MeatballMenu
      id={ids.list_search_item(codeItem.id)}
      onExpandMenu={handleLoadCodesAccess}
      onCloseMenu={handleClearCodesAccess}
      className={styles.meatball}>
      {hasNoAccess
        ? <li>
          <p className={styles.labelNoAccess}>{translation.no_access_has_been_granted}</p>
        </li>
        : !!fetchingItemAccess
          ? <div className={styles.loader}>
            <ElementLoader />
          </div> : <>
            {canCreate && isHierarchy && <li>
              {addLinkFactory(!!translation && translation.add_child, breadcrumbs, codeItem.id, undefined)}
            </li>}
            {canCreate && isHierarchy && <li>
              {addLinkFactory(!!translation && translation.add_sibling, breadcrumbs, parentId, undefined)}
            </li>}
            {canDuplicate && <li>
              {addLinkFactory(!!translation && translation.duplicate_code, breadcrumbs, undefined, codeItem.id)}
            </li>}

            {canDelete && <li>
              <PromptConfirmationModal
                title={translation.delete_code_item}
                description={description}
                continueText={translation.delete_code_item}
                cancelText={translation.cancel}
                onContinue={handleDeleteCodeItem}>
                <button type="button" className="dropdown-item">
                  {!!translation && translation.delete}
                </button>
              </PromptConfirmationModal>
            </li>}
          </>}
    </MeatballMenu>}
  </div>;
};
